/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_Audio_SpeakerInputs */



/**
* | output |
* | --- |
* | "Speaker" |
*
* @param {Practice_Session_Audio_SpeakerInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_audio_speaker = /** @type {((inputs?: Practice_Session_Audio_SpeakerInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Audio_SpeakerInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Luidspreker")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Haut-parleur")
	return /** @type {LocalizedString} */ ("Speaker")
});